import { Fragment } from "react";

const PlansComparison = (props: {
  className?: string;
  items: {
    text?: string | JSX.Element;
    className?: string;
  }[][];
}) => {
  return (
    <div className={`card bg-white !text-black shadow-none w-full grid gap-x-2 gap-y-3 text-sm grid-cols-5 sm:grid-cols-6 ${props.className || ""}`}>
      {
        props.items.map((item, i) => (
          <Fragment key={i.toString()}>
            {
              item.map((x, j) => (
                <span key={j.toString()} className={!j ? "col-span-3 sm:col-span-4" : "font-medium text-center"}>{x.text}</span>
              ))
            }
          </Fragment>
        ))
      }
    </div>
  );
}

export default PlansComparison;